export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_ERROR = "LOGIN_USER_ERROR";

export const AUTH_REFRESH_TOKEN = "AUTH_REFRESH_TOKEN";
export const AUTH_REFRESH_TOKEN_SUCCESS = "AUTH_REFRESH_TOKEN_SUCCESS";

export const loginUser = (user, history) => ({
  type: LOGIN_USER,
  payload: { user, history },
});
export const loginUserSuccess = (token) => ({
  type: LOGIN_USER_SUCCESS,
  payload: token,
});
export const loginUserError = (message) => ({
  type: LOGIN_USER_ERROR,
  payload: { message },
});


// REFRESH TOKEN
export const refreshNewToken = (payload) => ({
  type: AUTH_REFRESH_TOKEN,
  payload
});

export const refreshNewTokenSuccess = (payload) => ({
  type: AUTH_REFRESH_TOKEN_SUCCESS,
  payload
});